import { useState, useEffect,useRef } from "react";

const useMultiStepForm = (initialData = {}, storageKey = "formData",fabricOptions = [],) => {
    const isInitialized = useRef(false);
    const [imageFiles, setImageFiles] = useState([]);      // File[]
    const [imagePreviews, setImagePreviews] = useState([]); // string[]
    const [attachments, setAttachments] = useState([]);        // File[]
const [attachmentPreviews, setAttachmentPreviews] = useState([]); // string[]
const [productImages, setProductImages] = useState([]);
const [productImagePreviews, setProductImagePreviews] = useState([]);


    const [currentStep, setCurrentStep] = useState(1);
    // const [formData, setFormData] = useState(() => {
    //     // Load from localStorage on initial render
    //     const savedData = localStorage.getItem(storageKey);
    //     return savedData ? JSON.parse(savedData) : initialData;
    // });
     const [formData, setFormData] = useState(initialData);
    
     useEffect(() => {
    if (isInitialized.current) return;

    const savedData = localStorage.getItem(storageKey);

    if (savedData && Object.keys(initialData).length === 0) {
      setFormData(JSON.parse(savedData));
    } else if (Object.keys(initialData).length > 0) {
      setFormData(initialData);
      localStorage.removeItem(storageKey); // ⬅️ penting
    }

    isInitialized.current = true;
  }, [initialData, storageKey]);
  

    // Save to localStorage whenever formData changes
    useEffect(() => {
        localStorage.setItem(storageKey, JSON.stringify(formData));
    }, [formData, storageKey]);

    // const handleChange = (e) => {
    //     const { id, value, type, checked } = e.target;
    //     setFormData(prev => ({
    //         ...prev,
    //         [id]: type === 'checkbox' ? checked : value
    //     }));
    // };
    const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: type === "checkbox" ? checked : value
    }));
  };
  
 const handleFabricChange = (e) => {
  const selectedId = e.target.value;

  // 🚫 jika masih placeholder
  if (!selectedId) {
    setFormData(prev => ({
      ...prev,
      fabric_id: "",
      fabric_type: "",
      product_description: "",
      fabric_product_description: "",
      color: "",
      image:"",
    }));
    return;
  }

  if (!fabricOptions?.length) return;

  const selectedOption = fabricOptions.find(
    opt => String(opt.value) === String(selectedId)
  );

  // 🚫 safety
  if (!selectedOption || !selectedOption.raw) return;

  const fabric = selectedOption.raw;

  setFormData(prev => ({
    ...prev,
    fabric_id: selectedId,
    fabric_type: fabric.material || "",
    product_description: fabric.detailProduct?.name || "",
    fabric_product_description: fabric.description || "",
    color: fabric.color || "",
    image: fabric.image || "",
  }));
};


// const handleFabricChange = (e) => {
//     const selectedId = e.target.value;

//     console.log("🧵 SELECTED FABRIC ID:", selectedId);
//     console.log("🧺 FABRIC OPTIONS:", fabricOptions);

//     if (!fabricOptions || fabricOptions.length === 0) {
//         console.warn("⚠️ FABRIC OPTIONS EMPTY");
//         return;
//     }

//     const selectedOption = fabricOptions.find(
//         opt => String(opt.value) === String(selectedId)
//     );

//     if (!selectedOption) {
//         console.warn("❌ FABRIC NOT FOUND");
//         return;
//     }

//     const fabric = selectedOption.raw;

//     console.log("🧶 FABRIC RAW DATA:", fabric);

//     setFormData(prev => ({
//         ...prev,
//         fabric_id: selectedId,

//         // AUTO FILL
//         fabric_type: fabric.material || "",
//         product_description: fabric.detailProduct?.name || "",
//         fabric_product_description: fabric.description || "",
//         color: fabric.color || ""
//     }));
// };

    // const handleImageChange = (id, file) => {
    //     setFormData(prev => ({
    //         ...prev,
    //         [id]: file
    //     }));
    // };

    // const handleSwitch = (id, checked) => {
    //     setFormData(prev => ({
    //         ...prev,
    //         [id]: checked
    //     }));
    // };

  //  const handleImageChange = (field, e) => {
  //   const file = e?.target?.files?.[0];
  //   if (!file) return;

  //   const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
  //   if (!allowedTypes.includes(file.type)) {
  //     alert("Only JPG, JPEG, and PNG images are allowed.");
  //     e.target.value = "";
  //     return;
  //   }

  //   setFormData(prev => ({
  //     ...prev,
  //     [field]: file
  //   }));

  //   const previewUrl = URL.createObjectURL(file);
  //   setImagePreview(previewUrl);
  // };
const handleAttachmentChange = (e) => {
   const files = Array.from(e.target.files);
  processAttach(files)
};

const handleImageChange = (e) => {
  const files = Array.from(e.target.files);
  processImages(files)
};


const handleDrop = (e) => {
  e.preventDefault();
  const files = Array.from(e.dataTransfer.files);
  processImages(files);
};

const handleDropAttach = (e) => {
  e.preventDefault();
  const files = Array.from(e.dataTransfer.files);
  processAttach(files);
};

const processImages = (files) => {
  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  const validFiles = files.filter(file =>
    allowedTypes.includes(file.type)
  );

  const previews = validFiles.map(file =>
    URL.createObjectURL(file)
  );

  setProductImages(prev => [...prev, ...validFiles]);
  setProductImagePreviews(prev => [...prev, ...previews]);

  // 🔥 PENTING: sinkron ke formData
  setFormData(prev => ({
    ...prev,
    product_image: [...(prev.product_image || []), ...validFiles],
  }));
};



const processAttach = (files) => {
  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  const validFiles = files.filter(file =>
    allowedTypes.includes(file.type)
  );

  const previews = validFiles.map(file =>
    URL.createObjectURL(file)
  );

  setAttachments(prev => [...prev, ...validFiles]);
  setAttachmentPreviews(prev => [...prev, ...previews]);

  // 🔥 PENTING: sinkron ke formData
  setFormData(prev => ({
    ...prev,
    attachments: [...(prev.attachments || []), ...validFiles],
  }));
};




const removeImage = (index) => {
  URL.revokeObjectURL(productImagePreviews[index]);
  // setProductImages(prev => prev.filter((_, i) => i !== index));
  setProductImagePreviews(prev => prev.filter((_, i) => i !== index));

  setFormData(prev => ({
    ...prev,
    product_image: prev.product_image.filter((_, i) => i !== index),
  }));
};

const removeAttach = (index) => {
  URL.revokeObjectURL(attachmentPreviews[index]);

  // setImageFiles(prev => prev.filter((_, i) => i !== index));
  setAttachmentPreviews(prev => prev.filter((_, i) => i !== index));

  setFormData(prev => ({
    ...prev,
    attachments: prev.attachments.filter((_, i) => i !== index),
  }));
};

useEffect(() => {
  return () => {
    imagePreviews.forEach(url => URL.revokeObjectURL(url));
  };
}, []);

useEffect(() => {
  return () => {
    attachmentPreviews.forEach(url => URL.revokeObjectURL(url));
  };
}, []);



  // cleanup memory
  // useEffect(() => {
  //   return () => {
  //     if (imagePreview) URL.revokeObjectURL(imagePreview);
  //   };
  // }, [imagePreview]);




  const handleSwitch = (id, checked) => {
    setFormData(prev => ({
      ...prev,
      [id]: checked
    }));
  };

    const nextStep = () => {
        setCurrentStep(prev => prev + 1);
    };

    const prevStep = () => {
        setCurrentStep(prev => prev - 1);
    };

    const clearStorage = () => {
        localStorage.removeItem(storageKey);
        setFormData(initialData);
        setCurrentStep(1);
    };

   return {
  currentStep,
  formData,
  setFormData,

  handleChange,
  handleFabricChange,

  // 🔥 FILE STATE (WAJIB)
  productImages,
  productImagePreviews,
  attachments,
  attachmentPreviews,

  processImages,
  processAttach,
  removeImage,
  removeAttach,

  handleDrop,
  handleDropAttach,
  handleAttachmentChange,
  handleImageChange,

  handleSwitch,
  nextStep,
  prevStep,
  clearStorage,
};


};

export default useMultiStepForm;